module.exports = __webpack_public_path__ + "img/6.ed5c4700.jpg";